import React from "react";
import "../../Css/UserPaine.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Middleware/context/AuthContext";





function UserPainel() {
const navigate=useNavigate();
const { 
  soldOrders,
  totalPending,
   totalSold,
    userProfile,
  }
  =useAuth()









  return (
    <div className="dashboardp">
      <aside className="sidebarp">
        <h2 >Tou Aki</h2>
        <ul>
          <li>🏠 Início</li>
          <li onClick={()=> navigate('/User/Orders')}>🛒 Meus Pedidos</li>
          <li>📍 Endereço</li>
          <li onClick={()=> navigate('/User/Profile')}>⚙️ Perfil</li>
          <li onClick={()=> navigate("/Home")} className="logoutp">Sair</li>
        </ul>
      </aside>

      <main className="contentp">
        <h1>Bem-vindo 👋</h1>

        <div className="cardsp">
          <div className="cardp">
            <h3>Pedidos</h3>
            <p>{totalPending}</p>
          </div>

          <div className="cardp">
            <h3>Entregas</h3>
            <p>{totalSold}</p>
          </div>

          <div className="cardp">
            <h3>Saldo Disponivel</h3>
            <p>Atualizar</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default UserPainel;
